export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
const QUARTER_HOUR_MS = 15 * MINUTE_MS;

export function wallTime(parts: readonly string[]): number {
  const [year, month, day, hour, minute, second] = parts.map(Number) as [number, number, number, number, number, number];
  return Date.UTC(year, month - 1, day, hour, minute, second);
}

const LOCAL_TIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/;

export function parseLocalTime(value: string): number | undefined {
  const match = LOCAL_TIME.exec(value);
  return match ? wallTime(match.slice(1, 7)) + Number((match[7] ?? '').padEnd(3, '0')) : undefined;
}

export const wallNow = (): number => Date.now() - new Date().getTimezoneOffset() * MINUTE_MS;

export const roundToQuarterHour = (ms: number): number => Math.round(ms / QUARTER_HOUR_MS) * QUARTER_HOUR_MS;

export function median(values: readonly number[]): number | undefined {
  if (values.length === 0) return undefined;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = sorted.length >> 1;
  return sorted.length % 2 ? sorted[mid]! : (sorted[mid - 1]! + sorted[mid]!) / 2;
}
